import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';
import localforage from "localforage";

import '../css/App.css';


class Home extends Component {

  constructor(props) {
    super(props);
    // Setting up initial state
    this.state = {
      url: "http://adm.pixirt.com/api/artigos?_format=json",
      pager: { current_page: 0, total_items: 0, total_pages: 0, items_per_page: 0 },
      listaItens: []
    }

    this.Connection = this.Connection.bind(this);
    this.PrevPage = this.PrevPage.bind(this);
    this.NextPage = this.NextPage.bind(this);
  }

  PrevPage(event){
    let pager = this.state.pager;
    if(pager.current_page > 0){
      pager.current_page = pager.current_page -1;
      this.setState({ pager: pager });
      this.Connection();
    }
  }

  NextPage(event){
    let pager = this.state.pager;
    if(pager.current_page < (pager.total_pages-1)){
      pager.current_page = pager.current_page +1;
      this.setState({ pager: pager });
      this.Connection();
    }
  }

  // calling the componentDidMount() method after a component is rendered for the first time
  componentDidMount() {
    this.Connection();

  }

  // calling the componentWillUnMount() method immediately before a component is unmounted from the DOM
  componentWillUnmount() {
    // this.serverRequest.abort();
  }

  // action to consmume a REST resource
  Connection(){
    var th = this;
    var LISTAITENS = 'listaItens_'+this.state.pager.current_page;
    var PAGER = 'pager';
    var PAGE = this.state.pager.current_page;
    var URL = this.state.url + "&page=" + PAGE;

    const cache = setupCache({
      maxAge: 15 * 60 * 1000,    //15 minutes
      store: localforage
    })

    const api = axios.create({
      adapter: cache.adapter
    })

      // Feel free to change the drivers order :)
      localforage.setDriver([
        // localforage.INDEXEDDB,
        // localforage.WEBSQL,
        localforage.LOCALSTORAGE

      ]).then(function() {

        // verifica se o cache esta vazio
        localforage.getItem(LISTAITENS, function(err, readValue) {
          // consulta a api
          api({
            url: URL,
            method: 'get'
          })
          .then( response => {
            // Interacting with the store, see `localForage` API.
            localforage.setItem(LISTAITENS, response.data).then(function () {
              return localforage.getItem(LISTAITENS);

            })
            .then(function (value) {
              // seta o resultado da api no readValue
              th.setState({ listaItens: value.rows });
              th.setState({ pager: value.pager });
              readValue = value;

            })
            .catch(function (err) {
              // erro
              console.log(err);
            });
          })
          .catch( error => {
            console.log(error);
          });
          if(readValue){
            th.setState({ listaItens: readValue.rows });
            th.setState({ pager: readValue.pager });
          }

        });

      });
  }

  render() {

    if(this.state.listaItens.length > 0){
      return (
        <div className="content">
          <h1 className="title">Últimas Postagens</h1>
          { this.state.listaItens.map( (item, index) => (
            <div className={"row post-item item-" + index} key={item.nid}>
              <div className="col-xs-12">
                <h3 className="titulo">{item.title}</h3>
                <h4 className="datetime">
                  {item.created}
                </h4>
                <div className="corpo">{ReactHtmlParser(item.body)}</div>
              </div>
            </div>
          ))}
          <div className="row paginacao">
            <div className="col-xs-12">
              <button className="btn btn-primary pull-left" onClick={this.PrevPage}>Anterior</button>
              <button className="btn btn-primary pull-right" onClick={this.NextPage}>Próximo</button>
            </div>
          </div>
        </div>
      );

    }else{
      return (
        <div className="content">
          <h1 className="title">Projetos</h1>
          <div className="row post-item">
            <div className="col-xs-12">
              <h3 className="titulo text-center">Ops! ainda não temos conteúdo publicado!</h3>
            </div>
          </div>
        </div>
      );
    }

  }

}

export default Home;



// WEBPACK FOOTER //
// ./src/controller/Home.js